import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";

const fetchLsqAdminUsers = (enabled = true) => {
    return useQuery(
        ["lsq-admin-users"],
        () =>
            request({
                url: `lsq/admin/users`,
                method: "GET",
            }),
        { enabled }
    );
};

export { fetchLsqAdminUsers };
